<template>
<pop-up-layout 
  :title="$t('promociones.representantes')"
  :description="$t('promociones.textoRepresentantes')"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  :disabled="!cambiado"
  @volver="$parent.hide()"
  @aceptar="guardar"
  :aceptar="!loading && representantes.length > 0 ? $t('general.misc.guardarCambios') : null"
>
  <o-base-justify-text v-if="representantes.length > 0">
    {{$t('promociones.representantesDatos')}}
  </o-base-justify-text>
  <o-description-title v-if="representantes.length < 1">
    {{$t('promociones.noRepresentantes')}}
  </o-description-title>
  <v-form v-model="valid" ref="form">
    <v-slide-y-transition group tag="div">
      <v-layout :column="$vuetify.breakpoint.xsOnly" mb-3 mt-3
        v-for="(representante, i) in representantes"
        :key="'representante'+ representante.id_temporal"
        align-center
      >
        <v-card row style="width: 100%">
          <v-card-text class="pt-1">
            <o-medium-title-erase :botonBorrar="false">{{$t('promociones.datosRepresentante') + (i+1)}}</o-medium-title-erase>
            <v-layout :column="$vuetify.breakpoint.mdAndDown" align-center pa-2>
              <v-layout style="min-width: 200px" :style="$vuetify.breakpoint.mdAndDown ? 'margin-bottom:10px' : ''">
                <v-flex xs12 px-2>
                  <v-layout column justify-center align-center>
                    <label class="text-xs-center mb-2" style="color: grey;font-weight: 300;font-size: smaller;">
                      {{$t('promociones.addFirma')}}
                    </label>
                    <FileUploader
                      :subPopUp="true"
                      :name="'firma['+ i +']'"
                      style="height:118px; width: 150px"
                      :maxNum="1"
                      v-model="representante.firma"
                      :deletable="true"
                      accept="image/png"
                      :imagesOnly="true"
                    />
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="width:100%">
                <v-flex xs12 sm6 md6 lg6 px-2>
                  <v-text-field
                    :name="'nombre['+ i +']'"
                    :label="$t('general.misc.nombre')"
                    disabled
                    v-model="representante.nombre"
                  />
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 px-2>
                  <v-select
                    :label="$t('promociones.tipoPersona')"
                    :name="'tipoPersona[' + i + ']'"
                    :items="tiposRepresentantes"
                    item-text="text"
                    item-value="value"
                    v-model="representante.tipoPersona"
                    disabled>
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 px-2 v-if="representante.tipoDocumento !== 'J'">
                  <v-select 
                    :label="$t('comerciales.tipoDocumento')"
                    :name="'tipoDocumento[' + i + ']'"
                    :items="tiposDocumentos"
                    item-text="text"
                    item-value="value"
                    v-model="representante.tipoDocumento"
                    disabled>
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 px-2>
                  <v-text-field
                    :label="$t('comerciales.numDocumento')"
                    v-model="representante.numeroDocumento"
                    disabled
                  />
                </v-flex>
                <v-flex xs12 sm8 md8 lg8 px-2>
                  <v-text-field
                    :label="$t('general.misc.email')"
                    v-model="representante.email"
                    disabled
                  >
                    <template slot="append">
                      <v-tooltip bottom>
                        <template #activator="{on}">
                          <v-icon style="pointer-events:all; cursor: default;" small v-on="on" @click.stop>
                            info
                          </v-icon>
                        </template>
                        <span>{{$t('reservas.kyc.tooltipEmail')}}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4 px-2>
                  <v-text-field
                    :label="$t('general.misc.telefono')"
                    v-model="representante.movil"
                    disabled
                  >
                  <template slot="append">
                    <v-tooltip bottom>
                      <template #activator="{on}">
                        <v-icon style="pointer-events:all; cursor: default;" small v-on="on" @click.stop>
                          info
                        </v-icon>
                      </template>
                      <span>{{$t('reservas.kyc.tooltipTelefono')}}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-space-between
              :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''">
                <v-flex xs12 px-2>
                  <v-checkbox
                    :ripple="false"
                    disabled
                    color="primary"
                    class="grey--text pl-2"
                    v-model="representante.esPorDefecto" 
                    :label="$t('promociones.representanteDefecto')"
                    style="pointer-events:none;"
                  />
              </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-slide-y-transition>
  </v-form>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import uniqid from 'uniqid'
import FileUploader from '@/components/generic/fileUploader/FileUploader'

export default {
  mixins: [rules],
  components: {
    FileUploader
  },
  props: {
    codigoPromocion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: true,
      representantes: [],
      mostrarBorrarRepresentante: false,
      valid: true,
      cambiado: false,
      borrar: ''
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromocion(this.codigoPromocion)
      await this.loadPromocionRepresentantes(this.codigoPromocion)
      this.representantes = this.getPromocionesRepresentantes.map(x => {
        return {
          ...x,
          firma: x.representante.documento_id !== null ? [{
            extension: x.representante.documento_extension,
            id: x.representante.documento_id,
            mime: x.representante.documento_mime,
            nombre: x.representante.documento_nombre
          }] : [],
          id_temporal: uniqid(),
          esPorDefecto: x.esPorDefecto,
          nombre: x.representante.nombreApellido,
          tipoDocumento: x.representante.tipoDocumento,
          numeroDocumento: x.representante.numeroDocumento,
          tipoPersona: this.tipoDocumento === 'J' ? 'J' : 'F'
        }
      })
      await this.$nextTick()
      this.loading = false
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      getPromocionesRepresentantes: 'promocionesRepresentantes/getAll'
    }),
    tiposDocumentos () {
      return [
        { value: 'N', text: this.$t('promociones.nif') },
        { value: 'P', text: this.$t('promociones.pasaporte') },
        { value: 'T', text: this.$t('promociones.nie') },
        { value: 'Y', text: this.$t('promociones.numContribuyente') },
        { value: 'J', text: this.$t('promociones.juridico') }
      ]
    },
    tiposRepresentantes () {
      return [
        { text: this.$t('promociones.fisica'), value: 'F' },
        { text: this.$t('promociones.juridica'), value: 'J' }
      ]
    },
    objetoParaApi () {
      return {
        representantes: this.representantes.map(x => {
          return {
            tipoDocumento: x.representante.tipoDocumento,
            numeroDocumento: x.representante.numeroDocumento,
            firma: x.firma
          }
        })
      }
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromocion: 'promociones/loadPromocion',
      loadPromocionRepresentantes: 'promocionesRepresentantes/loadAll',
      modificar: 'promocionesRepresentantes/modificar'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    mostrarAvisoBorrarRepresentante (i) {
      this.nombreBorrar = this.representantes[i].nombre
      this.indiceBorrar = i
      this.mostrarBorrarRepresentante = true
    },
    borrarRepresentante () {
      this.mostrarBorrarRepresentante = false
      this.representantes.splice(this.indiceBorrar, 1)
      this.indiceBorrar = -1
    },
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      for (let representante of this.representantes) {
        if (representante.firma.length === 1 && representante.firma[0].extension !== 'png') {
          this.addAlert({texto: this.$t('promociones.alertaImgTipo'), color: 'error'})
          return
        }
      }
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.modificar(this.objetoParaApi)
        // ({firmantes: this.firmantes, codigoPromocion: this.codigoPromocion})
        this.$emit('cambiado', false)
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('general.misc.cambiosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  watch: {
    representantes: {
      deep: true,
      handler () {
        if (!this.loading) {
          this.cambiado = true
          this.$emit('cambiado', this.cambiado)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

@media (max-width: 1200px)
    .buttonOtrosCompradores
      margin-top:0 !important

@media (min-width: 1112px)
  .buttonOtrosCompradores
    margin-bottom:0 !important
    position: absolute 
    right: 10px
    top: 1%;

</style>



// WEBPACK FOOTER //
// src/components/promociones/PopUpPromocionesRepresentantes.vue